import { TIdentityInfo } from '@/modules/adjusterReportModules/IncidentParticipants/queries/personalInquiryQuery/personalInquiry.types';
import { create } from 'zustand';

type PersonalInquiryStore = {
  data: TIdentityInfo;
  setInquiryData: (data: TIdentityInfo) => void;
  clearInquiryData: () => void;
};

const usePersonalInquiryStore = create<PersonalInquiryStore>((set) => ({
  data: {} as TIdentityInfo,
  setInquiryData: (data: TIdentityInfo) => set({ data }),
  clearInquiryData: () => set({ data: {} as TIdentityInfo }),
}));

export default usePersonalInquiryStore;
